var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeaturedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.361,
    height: 32.5,
    viewBox: "0 0 24.361 32.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1338",
    "data-name": "Group 1338",
    transform: "translate(-1719 -318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "featured",
    d: "M0,16.259V2.636A2.422,2.422,0,0,1,2.616,0H21.665a2.433,2.433,0,0,1,2.689,2.686q0,10.61.007,21.219a.98.98,0,0,1-.393.867c-3.036,2.441-6.052,4.906-9.094,7.34a1.769,1.769,0,0,1-1.019.37c-3.7.025-7.394.017-11.092.014A2.455,2.455,0,0,1,0,29.76Zm22.89,7.354V2.834c0-1.068-.274-1.333-1.366-1.333H2.848c-1.121,0-1.386.263-1.386,1.368v26.87c0,.925.3,1.249,1.206,1.25q5.212.007,10.423,0c.172,0,.344-.03.547-.049v-4.5a2.633,2.633,0,0,1,2.819-2.825H22.89Zm-8.5,6.993,7.641-6.2c-2.136,0-4.132-.051-6.121.024a1.588,1.588,0,0,0-1.5,1.616c-.06,1.459-.017,2.919-.017,4.562Z",
    transform: "translate(1719 318)",
    fill: "#c5c6c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "star",
    d: "M11.572,14.6,7.151,11.362,2.645,14.484,4.362,9.277,0,5.957l5.482.024L7.292.806,8.964,6.027l5.481.123L10,9.353Z",
    transform: "translate(1723.815 326.021)",
    fill: "#c5c6c9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedIcon);
export default __webpack_public_path__ + "static/media/Featured-Icon.493704fe00771e86471f23f6ff8fdb1b.svg";
export { ForwardRef as ReactComponent };